<template>
  <div>
    <van-search
      v-model="value"
      placeholder="请输入搜索关键词"
      show-action
      @search="onSearch"
      background="#fff"
    >
      <div slot="action" @click="onSearch" class="search-btn">搜索</div>
    </van-search>
  </div>
</template>
<script>
import { Search } from "vant";
export default {
  name: "search-bar",
  data() { 
    return {
      value: ""
    };
  },
  components: {
    [Search.name]: Search
  },
  methods: {
    onSearch() {
      // this.$router.push({
      //   name:'list',
      //   params:{foodName:this.value}
      // })
      // this.$router.push({
      //   path: "/eating/list",
      //   query: {foodName:this.value}
      // });
      this.$emit("onSearch", this.value);
    }
  }
};
</script>
<style lang="less">
.van-search {
  border-bottom: 1px solid #e5e5e5;
  & .van-cell {
    background: #f2f2f2;
  }
}
.van-search .search-btn {
  color: #ff789e;
  font-size: 18px
}
input.van-field__control::-webkit-input-placeholder {
    color: #CCCCCC;
    font-size: 14px;
}
.van-icon-search:before {
    // content: url('~@/assets/images/icon_search@2x.png');
    content:"";
    color: #ccc;
    width: 16px;
    height: 16px;
    background: url('~@/assets/images/icon_search@2x.png') no-repeat;
    background-size: cover
}
</style>


